var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    viewBox: "179 219 152 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    .st0 {\n      display: none;\n    }\n    .st1 {\n      display: inline;\n    }\n    .st2 {\n      fill: #ffffff;\n      stroke: #000000;\n      stroke-width: 0.1;\n      stroke-miterlimit: 10;\n    }\n    .st3 {\n      fill: none;\n      stroke: #000000;\n      stroke-width: 10;\n      stroke-miterlimit: 10;\n    }\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "216,288 184,256 216,224   "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 186.8,
    y1: 256,
    x2: 326,
    y2: 256
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBack);
export default __webpack_public_path__ + "static/media/icon-back.6b838ae26c6ec927c06baee753e2686a.svg";
export { ForwardRef as ReactComponent };